export default {
    loggingApiUrl: 'https://ep-loggingreports-api-prod-afd-acdqc4c8cbeddneu.a03.azurefd.net/api',
    clientId: 'b2767022-0849-4689-8d3f-ac5b982f0889',
    authority: 'https://login.microsoftonline.com/e5982410-a87c-4de2-966a-57de40702c63',
    LogLevel: 2,
    sampleRate: 0.5,
    sentryDsn: 'https://62cef205fc872a343f580ce581e74be0@o4509346579677184.ingest.de.sentry.io/4511300256464976'
};
